module.exports = __webpack_public_path__ + "img/12.93b069d9.svg";